import { handleActions } from "redux-actions";

import {
    ATTACHMENT_FETCH_SUCCESS,
    ATTACHMENT_ADD,
    ATTACHMENT_REMOVE,
    ATTACHMENT_SUCCESS,
} from "constants/action-types";

const initialState = {
    initialized: false,
    result: [],
    isFetching: false,
    error: undefined,
    updating: false,
};

const attachmentsReducer = handleActions(
    {
        [ATTACHMENT_FETCH_SUCCESS]: (state, { payload }) => {
            return Object.assign({}, state, {
                isFetching: false,
                initialized: true,
                result: payload,
            });
        },
        [ATTACHMENT_ADD]: (state) => {
            return Object.assign({}, state, { updating: false });
        },
        [ATTACHMENT_REMOVE]: (state, { payload }) => {
            const result = state.result.filter((id) => {
                return id !== payload;
            });
            return Object.assign({}, state, { updating: false, result });
        },
        [ATTACHMENT_SUCCESS]: (state, { payload }) => {
            const result = state.result.concat(payload);
            return Object.assign({}, state, { updating: false, result });
        },
    },
    initialState
);

export default attachmentsReducer;
